import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";

export default class extends Controller {
  static targets = [
    "verifiedFilter",
    "cityFilter",
    "dateFromFilter",
    "dateToFilter",
    "table"
  ];

  connect() {
    const tableElement = $(this.tableTarget);

    this.datatable = tableElement.DataTable({
      pageLength: 10,
      autoWidth: false,
      lengthMenu: [5, 10, 25, 50],
      order: [[0, "asc"]],
      searching: true,
      dom:
        "<'row mb-3'<'col-sm-6'l><'col-sm-6 text-end'>>" +
        "<'row mb-2'<'col-sm-12'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      language: { searchPlaceholder: "Search customers...", search: "" }
    });

    // Custom filters
    $.fn.dataTable.ext.search.push((settings, data) => {
      if (settings.nTable !== tableElement[0]) return true;

      const verifyFilter = this.verifiedFilterTarget.value;
      const rowVerified = data[5].toLowerCase().includes("yes");

      const cityFilter = this.cityFilterTarget.value.toLowerCase();
      const rowCity = data[4].toLowerCase();

      const dateFrom = this.dateFromFilterTarget.value;
      const dateTo = this.dateToFilterTarget.value;
      const createdAt = data[7]; // index if you add created date

      if (verifyFilter === "verified" && !rowVerified) return false;
      if (verifyFilter === "unverified" && rowVerified) return false;

      if (cityFilter && !rowCity.includes(cityFilter)) return false;

      if (dateFrom && createdAt < dateFrom) return false;
      if (dateTo && createdAt > dateTo) return false;

      return true;
    });

    [
      this.verifiedFilterTarget,
      this.cityFilterTarget,
      this.dateFromFilterTarget,
      this.dateToFilterTarget
    ].forEach(el => el.addEventListener("input", () => this.refresh()));
  }

  refresh() {
    this.datatable.draw();
  }

  clearFilters() {
    this.verifiedFilterTarget.value = "";
    this.cityFilterTarget.value = "";
    this.dateFromFilterTarget.value = "";
    this.dateToFilterTarget.value = "";

    this.datatable.search("").draw();
    this.datatable.draw();
  }
}
